import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

defineBlock({
    type: 'var_set_number',
    colour: CATEGORIES.variable.color,
    tooltip: '数値変数に値を代入します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/var_number.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('変数セット', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('数値'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () => new FieldVariableLabel('設定する変数', { fontWeight: 'normal', varType: 'float' }),
                },
                { type: 'label', text: 'に' },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'を入れる ' }],
        },
    ],
});
